import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServicesService } from '../services.service';
import {environment} from '../../environments/environment';
import swal from 'sweetalert2';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.css']
})
export class CartComponent implements OnInit {

    apiBaseUrl: string        = environment.apiBaseUrl;
    header                    = 'l-header';
    navbar                    = 'l-navbar l-navbar_t-light l-navbar_expand js-navbar-sticky';
    getCartDetailResults: any = '';
    productArray              = [];
    subTotal                  = 0;
    shipmentCharge            = 0;
    taxTotal                  = 0;
    finalAmount               = 0;
    onlineFee                 = 0;
    shippingAddress           = '';
    userId                    = '';
    jobId                     = '';
    clientType;
    showSubTotal               = 0;
    showtotal                 = 0;
    finalAmountshow           = 0;
    subTotalshow              =0; 
    erMsg;
    addressErr=0;
    studentDet = [];
    pName:string = '';
    cName:string = '';
    sName:string = '';
    newPrice     =0;
    amount        =0;
    displayTax    =0;
    displaysubTotal =0;
    urlPayment:any;
    PaymentReturnUrl=  environment.apiUrl+'/payment/response';
    ForpaymentUrl = environment.paymentUrl;

    paymentType:string = '  this.paymentType';
    amountFromApi=0;
    paymentFormGroup:FormGroup;
    @ViewChild('testForm') testFormElement;
    @ViewChild('amountPayment') amountPayment;
    @ViewChild('signaturePayment') signaturePayment;
    @ViewChild('noncePayment') noncePayment;
    @ViewChild('merchantTransactionIdPayment') merchantTransactionIdPayment;
    // @ViewChild('defaultPaymentMethod') defaultPaymentMethod;
    @ViewChild('entityId') entityId;
    
    

    
    amountForPayment=0;
    signature='';
    nonce:any;
    merchantTransactionId:any;



    constructor(private route: ActivatedRoute, private _service: ServicesService, private router: Router,private FormBuilder: FormBuilder) { }


  ngOnInit() {
     this.getCartDetails();
     this. getorderPrice() ;
     
    //  this.paymentFormGroup = this.FormBuilder.group({
    //     amount: [''],
    //     authentication_entityId: ['8ac7a4c8708b8dae01708be6bb3b018e'],
    //     currency: ['ZAR'],
    //     defaultPaymentMethod: ['CARD'],
    //     merchantTransactionId: [''],
    //     // shopperResultUrl: [''],
    //     nonce:[''],
    //     paymentType:['DB'],
    //     shopperResultUrl:['http://185.25.48.10/photography/check.php'],
    //     signature: ['']
    //   });
  
   
  }

    updateAddress() {
        console.log('this.shippingAddress', this.shippingAddress);
        const data = {'userId': this.userId, 'shippingAddress': this.shippingAddress};
        this._service.updateAddress(data).subscribe((res: any) => {
            if (res.status === 200) {
                const persons = JSON.parse(localStorage.userData);
                const inputName = 'shipping_address'
                persons.shipping_address = this.shippingAddress;
                localStorage.setItem('userData', JSON.stringify(persons));
                swal({
                    title: 'Done!',
                    text: 'Something Went Wrong, Please Try Again',
                    type: 'success',
                    html:  'Address Update Successfully',
                    confirmButtonText: 'Ok',
                    showConfirmButton: true,
                });
            }else {
                swal({
                    title: 'Oops!',
                    text: 'Something Went Wrong, Please Try Again',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                    showConfirmButton: true,
                });

            }

        });
    }

    showImage(src) {

        const imgUrl = this.apiBaseUrl + '/' + src;
       // console.log(imgUrl);

        swal({
            html:  "<img src='" + imgUrl + "' style='width:100%;'>",
            showConfirmButton: false,
            customClass: 'swal-wide',
        });
    }
    getCartDetails() {
        const userData = JSON.parse(localStorage.getItem('userData'));
        if (userData) {
            this.userId = userData.hasOwnProperty('id') ? userData.id : '';
            this.shippingAddress = userData.shipping_address;
            const data = {'user_id': this.userId};
            this._service.getCartDetails(data).subscribe((result: any) => {

                $('.tb-preloader-wave').fadeOut();
                $('#tb-preloader').delay(200).fadeOut('slow').remove();

                this.getCartDetailResults = result.result;
                console.log(this.getCartDetailResults);
                // this.getCartDetailResults.forEach(element => {
                //     console.log(element);
                    
                // });

                for (const obj in this.getCartDetailResults) {
                    // console.log(obj)
                    this.jobId = this.getCartDetailResults[obj][0]['job_id'];
                    console.log(this.jobId);
                    // alert(this.jobId);
                    this.productArray.push(this.getCartDetailResults[obj][0]);
                }
                this.jobId = this.productArray[0]['job_id'];
                this.clientType = result.clien_type;
                this.getShipmentCharge(this.jobId);
    
                 this.productArray.map(function(productArray){
                      this.amount =  this.getSubTotalAmoutShow(productArray.price); 
                        productArray.price=this.amount;    
                 },this);
               
            });
        }
    }

    

    getSubTotalAmout() {
        let localSubTotal = 0;
        // console.log(this.productArray);
        this.productArray.map((item, index) => {

            localSubTotal += item['price'] * item['quantity'];
        });


        
        this.shipmentCharge = this.shipmentCharge;
            this.subTotal = localSubTotal;
            //  t =  this.subTotal
            this.displaysubTotal = parseFloat(this.toFixed(this.subTotal,2))
        this.taxTotal        = ((this.subTotal) * 15) / 100;
        this.displayTax      =  parseFloat(this.toFixed((((this.subTotal) * 15) / 100),2));
        this.displaysubTotal = this.displaysubTotal- this.displayTax;
        this.subTotal = this.subTotal-((this.subTotal) * 15) / 100;
        // this.finalAmount =  this.shipmentCharge + this.subTotal + this.taxTotal;
        // this.onlineFee = 1.5 + (this.finalAmount *3.5)/100;
        this.finalAmount =  this.shipmentCharge + this.subTotal +this.taxTotal;

    }

    getShipmentCharge(jobId) {

        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken');
        const data = {'token': token };

        this._service.getShipmentCharge(data).subscribe((data: any) => {
               if(data.status ==200 && data.result == true){
                   this.shipmentCharge =100;
               }else{
                   this.shipmentCharge =0;
               }
        });
    }

    onChange(event, product_id, add_to_cart_id)  {
     

        const userData = JSON.parse(localStorage.getItem('userData'));
        const user_id     = userData.hasOwnProperty('id') ?  userData.id : '';

        const data = {'user_id': user_id, 'product_id': product_id, 'add_to_cart_id': add_to_cart_id, 'quantity': event};

        if (event >= 1) {

           this._service.onChangeQuantity(data).subscribe((res: any) => {
               if (res.status === 200) {
               
                    this.productArray.map((item, index) => {
                        if (item['add_to_cart_id'] === add_to_cart_id) {
                            item['quantity'] = event;
                            swal({
                                title: 'Done!',
                                text: 'Quantity updated',
                                type: 'success'
                            });
                        }
                    });
                    // window.location.reload();
               }
           });
        }else {
            swal({
                title: 'Opss!',
                text: 'Quantity should be greater than 0',
                type: 'error'
            });
        }
        window.location.reload();

    }

    deleteProduct(product_id, add_to_cart_id, is_saleable, job_id)  {

        const userData = JSON.parse(localStorage.getItem('userData'));
        const user_id     = userData.hasOwnProperty('id') ?  userData.id : '';
        const that = this;
        const data = {'user_id': user_id, 'product_id': product_id, 'add_to_cart_id': add_to_cart_id, 'job_id': job_id };
        if(is_saleable){
            swal({
                title: 'Oops!',
                html: "Please note that if you remove the required products from your cart, any additional products will automatically be removed",
                type: 'warning',
                confirmButtonText: 'Ok',
                showCancelButton: true,
                focusCancel: true,
                cancelButtonColor: '#d33',
              }).then((willDelete) => {
                if (willDelete.value) {
                    that._service.deleteProduct(data).subscribe((res: any) => {
                        if (res.status === 200) {
                            that.productArray.map((item, index) => {
                                if (item['add_to_cart_id'] === add_to_cart_id) {
                                    window.location.reload();
                                    //this.productArray.splice(index,1);
                                }
                            });
                        }
                    });          
                }
              });
        }else{
            that._service.deleteProduct(data).subscribe((res: any) => {
                if (res.status === 200) {
                    that.productArray.map((item, index) => {
                        if (item['add_to_cart_id'] === add_to_cart_id) {
                            swal({
                                title: 'Done!',
                                text: 'Product has been deleted!',
                                type: 'success'
                            });
                            window.location.reload();
                            //this.productArray.splice(index,1);
                        }
                    });
                }
            });
        }
        

    }

    setPaymentType(type){
        this.paymentType = type;
        // alert(this.paymentTypeype);
    }
    toFixed( num, precision ) {
        return (+(Math.round(+(num + 'e' + precision)) + 'e' + -precision)).toFixed(precision);
    }

    checkoutProduct(amount) {
        // console.log( amount.toFixed(2));
        this.paymentType="CARD";
      
        let data = {};
        //address blank check added :: Utkarsh
        this.addressErr = 0;
        //adding student details in case when the client type is school
        if((this.pName=='' || this.sName=='' || this.cName=='') && this.clientType=='school'){
            this.erMsg='Please fill all the above fields';
            if(this.shipmentCharge == 100 && (this.shippingAddress.trim()=='' || this.shippingAddress.trim()==null)){
                this.addressErr = 1;
            }
        }else if(this.shipmentCharge == 100 && (this.shippingAddress.trim()=='' || this.shippingAddress.trim()==null)){
            this.erMsg = 0;
           this.addressErr = 1;
        }else{
            this.erMsg = 0;
            //amount =  Math.round(amount * 100) / 100
            amount = this.toFixed(amount,2);
            // console.log(this.toFixed(amount,2));
            const userData = JSON.parse(localStorage.getItem('userData'));
            const token = localStorage.getItem('userToken');

            const user_id     = userData.hasOwnProperty('id') ?  userData.id : '';
            if(this.clientType=='school'){
                let  dataSet = {
                    'pname': this.pName,
                    'sname':this.sName,
                    'cname':this.cName
                }
                data = {'price':  this.amountFromApi, 'token': token, 'student_data':dataSet,'defaultPaymentType':this.paymentType};
            }else{
                data = {'price':  this.amountFromApi, 'token': token ,'defaultPaymentType':this.paymentType};
            }

            this._service.checkoutProduct(data).subscribe((res: any) => {
                if (res.status === 200) {
                    console.log(res.result.merchantTransactionId);
                    this.amountForPayment      = res.result.amount;
                    // this.signature             = res.result.signature;
                    // this.nonce                 = res.result.nonce;
                    // this.merchantTransactionId =  res.result.merchantTransactionId;
                //     this.paymentFormGroup.patchValue({
                //         "signature":res.result.amount,
                //         "nonce":res.result.nonce,
                //         "merchantTransactionId":res.result.merchantTransactionId
                // });
                // this.testFormElement.amout=res.result.amountForPayment;
                // this.renderer.appendChild(this.el.nativeElement, div);
                // this.testFormElement.nativeElement.amount=112;
                // alert(this.paymentType);

                // console.log(this.paymentType);
                this.testFormElement.nativeElement.action=this.ForpaymentUrl;
                // this.defaultPaymentMethod.nativenativeElement=this.paymentType;
                
                // this.urlPayment = res.result.$urlPayment;
                this.amountPayment.nativeElement.value=this.amountForPayment;
                this.signaturePayment.nativeElement.value= res.result.signature;
                this.noncePayment.nativeElement.value= res.result.nonce;
                this.merchantTransactionIdPayment.nativeElement.value=res.result.merchantTransactionId;
                this.entityId.nativeElement.value=res.result.entityId;

                // signatureTest

                this.testFormElement.nativeElement.submit();
                     // console.log('here');
                    // this.router.navigate(['/orderprocessing']);
                    // if(this.paymentType == 'card'){
                    //     this.router.navigate(['/makepayment']);
                    // }else{
                    //     this.router.navigate(['/makepaymenteft']);
                    // }
                    // this._service.getPaymentStatusTest(res.result).subscribe((res: any) => {});

                    // this.testFormElement.nativeElement.submit();
                  
                    // window.open("https://testsecure.peachpayments.com/checkout","_blank", res.result);


                   
                }else {
                    swal({
                        title: 'Oops!',
                        text: 'Something went wrong. Please Try again!',
                        type: 'error'
                    });
                }
            });
        }

    }


    // checkoutProduct(amount){
        // console.log(this.paymentFormGroup);

        // this.paymentFormGroup.patchValue({
        //     amount:amount,
        //     merchantTransactionId:this.jobId
        // });  

    // }

    getSubTotalAmoutShow(price){
        // console.log('estdgedsc',price,quantity);

        
    //    if(price>0){
        this.subTotalshow = price*1;
        this.taxTotal = ((this.subTotalshow) * 15) / 100;
        this.finalAmountshow =   this.subTotalshow + this.taxTotal;
        this.onlineFee = 1.5 + (this.finalAmountshow *3.5)/100;
        this.finalAmountshow =  1*(this.onlineFee + this.finalAmountshow);
       
        
        // console.log(this.finalAmountshow);
        return  this.finalAmountshow;
    //    }
        

    }


    getorderPrice() {
        const userData = JSON.parse(localStorage.getItem('userData'));
        const token = localStorage.getItem('userToken');

        const user_id = userData.hasOwnProperty('id') ? userData.id : '';
        const data = {'token': token };
        this._service.getorderPrice(data).subscribe((res: any) => {
            if (res.status === 200) {
                this.amountFromApi = res.result;
                console.log(this.amountFromApi);
            }else {
                // this.router.navigate(['login']);
            }
        });
    }

    public moveBack() {
        // this.router.navigate(['product'], { queryParams: {'jobid': this.jobId}});
        this.router.navigate(['online-photo-order']);
    }
}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/cart/cart.component.ts